export function getApiMessage(source, fallback = 'Something went wrong') {
  if (!source) return fallback
  if (typeof source === 'string') return source.trim() || fallback

  const pickString = (val) =>
    typeof val === 'string' ? val.trim() : ''

  // Common top-level fields.
  const topLevel =
    pickString(source.message) ||
    pickString(source.Message) ||
    pickString(source.status_message) ||
    pickString(source.statusMessage) ||
    pickString(source.error) ||
    pickString(source.errorMessage) ||
    pickString(source.detail) ||
    pickString(source.reason)

  if (topLevel) return topLevel

  // Common nested shapes: { data: { message } } or { data: { items: { message } } }
  const data = source.data ?? source.Data ?? source.payload ?? source.Payload
  const nested =
    pickString(data?.message) ||
    pickString(data?.Message) ||
    pickString(data?.error) ||
    pickString(data?.reason)

  if (nested) return nested

  const items = data?.items
  const firstItemMessage =
    pickString(items?.message) ||
    (Array.isArray(items) ? pickString(items?.[0]?.message) : '')

  if (firstItemMessage) return firstItemMessage

  // GraphQL/AWS error arrays.
  const errorsNode = source.errors ?? source.Errors ?? data?.errors ?? data?.Errors
  const firstError = Array.isArray(errorsNode) ? errorsNode?.[0] : null

  if (firstError?.message) {
    const fromError = pickString(firstError.message)
    if (fromError) {
      try {
        const parsed = JSON.parse(fromError)
        return parsed?.message || fromError
      } catch {
        return fromError
      }
    }
  }

  return fallback
}

function hasListPayload(value) {
  if (value == null) return false
  if (Array.isArray(value)) return true
  if (typeof value !== 'object') return false

  const data = value.data
  if (Array.isArray(data)) return true
  if (data && typeof data === 'object') {
    if (Array.isArray(data.items) || Array.isArray(data.Items)) return true
    if (Array.isArray(data.calls) || Array.isArray(data.call_history)) {
      return true
    }
    if (
      Array.isArray(data.transactions) ||
      Array.isArray(data.org_transactions) ||
      Array.isArray(data.contact_us) ||
      Array.isArray(data.contactUs) ||
      Array.isArray(data.reachouts)
    ) {
      return true
    }
  }

  return (
    Array.isArray(value.items) ||
    Array.isArray(value.Items) ||
    Array.isArray(value.calls) ||
    Array.isArray(value.call_history) ||
    Array.isArray(value.transactions) ||
    Array.isArray(value.org_transactions) ||
    Array.isArray(value.contact_us) ||
    Array.isArray(value.contactUs) ||
    Array.isArray(value.reachouts)
  )
}

export function isApiSuccess(response) {
  if (response == null) return false

  if (Array.isArray(response)) return true

  if (typeof response !== 'object') return false

  const status = String(response.status ?? response.Status ?? '')
    .trim()
    .toUpperCase()

  if (status === 'ERROR' || status === 'FAIL' || status === 'FAILED') {
    return false
  }

  if (status === 'SUCCESS') return true
  if (response.success === true || response.ok === true) return true

  return hasListPayload(response)
}
